<template>
  <div>
    <h3>壁纸统计分析</h3>

    <div class="filter-bar">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        :shortcuts="shortcuts"
        :disabled-date="disabledDate"
        class="date-picker"
      />
      <div class="filter-group">
        <span class="filter-label">设备类型:</span>
        <el-select v-model="deviceType" placeholder="设备类型" clearable filterable>
          <el-option label="All" value="All" />
          <el-option v-for="item in deviceTypes" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="filter-group">
        <span class="filter-label">国家:</span>
        <el-select v-model="country" placeholder="国家" clearable filterable>
          <el-option label="All" value="All" />
          <el-option v-for="item in countries" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="filter-group">
        <span class="filter-label">广告系列ID:</span>
        <el-select v-model="campaignId" placeholder="广告系列ID" clearable filterable>
          <el-option label="All" value="All" />
          <el-option v-for="item in campaignIds" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="filter-group">
        <span class="filter-label">广告系列:</span>
        <el-select v-model="campaignName" placeholder="广告系列" clearable filterable>
          <el-option label="All" value="All" />
          <el-option v-for="item in campaignNames" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="filter-group">
        <span class="filter-label">广告组ID:</span>
        <el-select v-model="adGroupId" placeholder="广告组ID" clearable filterable>
          <el-option label="All" value="All" />
          <el-option v-for="item in adGroupIds" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="filter-group">
        <span class="filter-label">广告组:</span>
        <el-select v-model="adGroupName" placeholder="广告组" clearable filterable>
          <el-option label="All" value="All" />
          <el-option v-for="item in adGroupNames" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <el-button type="primary" @click="fetchData" :loading="loading">查询</el-button>
    </div>
    <div style="color: #E63D3D; font-size: 12px; margin-bottom: 10px;">
      注：GA4 数据存在 72 小时更新窗口，事件表每日导出、隔天17点才创建（每天17点30分定时任务更新）。定时任务更新近3天数据，按当前量级（约2.3万）预计有2%-3%的数据差异。事件表仅从开通BigQuery每日导出后（5月12日）开始有数据。
    </div>
    <div style="color: #999; font-size: 12px; margin-bottom: 10px;">
      Apply率 = Apply次数 / 预览次数；Succ率 = 成功次数 / Apply次数
    </div>

    <el-tabs v-model="activeTab" type="border-card" v-loading="loading">
      <el-tab-pane label="壁纸分类热度榜" name="category">
        <div style="overflow-x: auto;">
          <el-table :data="categoryData" stripe border :loading="loading" :default-sort="{ prop: 'preview_count', order: 'descending' }">
            <el-table-column prop="category" label="分类" :width="isSmallScreen ? 100 : 120" />
            <el-table-column prop="category_type" label="类型" :width="isSmallScreen ? 70 : 100" />
            <el-table-column prop="preview_count" label="预览PV" :width="isSmallScreen ? 70 : 100" sortable />
            <el-table-column prop="preview_count_uv" label="预览UV" :width="isSmallScreen ? 70 : 100" sortable />
            <el-table-column prop="apply_count" label="ApplyPV" :width="isSmallScreen ? 70 : 100" sortable />
            <el-table-column prop="apply_count_uv" label="ApplyUV" :width="isSmallScreen ? 70 : 100" sortable />
            <el-table-column prop="succ_count" label="成功PV" :width="isSmallScreen ? 70 : 100" sortable />
            <el-table-column prop="succ_count_uv" label="成功UV" :width="isSmallScreen ? 70 : 100" sortable />
            <el-table-column prop="apply_rate" label="Apply率(PV)" :width="isSmallScreen ? 70 : 100" sortable>
              <template #default="scope">
                {{ scope.row.apply_rate }}%
              </template>
            </el-table-column>
            <el-table-column prop="apply_rate_uv" label="Apply率(UV)" :width="isSmallScreen ? 70 : 100" sortable>
              <template #default="scope">
                {{ scope.row.apply_rate_uv }}%
              </template>
            </el-table-column>
            <el-table-column prop="succ_rate" label="Succ率(PV)" :width="isSmallScreen ? 70 : 100" sortable>
              <template #default="scope">
                {{ scope.row.succ_rate }}%
              </template>
            </el-table-column>
            <el-table-column prop="succ_rate_uv" label="Succ率(UV)" :width="isSmallScreen ? 70 : 100" sortable>
              <template #default="scope">
                {{ scope.row.succ_rate_uv }}%
              </template>
            </el-table-column>
            <el-table-column prop="avg_preview" label="人均预览" :width="isSmallScreen ? 70 : 90" sortable />
            <el-table-column prop="avg_apply" label="人均Apply" :width="isSmallScreen ? 70 : 90" sortable />
            <el-table-column prop="avg_succ" label="人均成功" :width="isSmallScreen ? 70 : 90" sortable />
          </el-table>
        </div>
      </el-tab-pane>

      <el-tab-pane label="具体壁纸热度Top20" name="wallpaper">
        <div class="filter-bar" style="margin: 16px 0; gap: 16px;">
          <div class="filter-group">
            <span class="filter-label">类型:</span>
            <el-select v-model="wallpaperCategoryType" placeholder="类型" clearable filterable>
              <el-option label="All" value="All" />
              <el-option label="Live" value="Live" />
              <el-option label="4K" value="4K" />
            </el-select>
          </div>
        </div>
        <div style="overflow-x: auto;">
          <el-table :data="wallpaperData" stripe border :loading="loading" :default-sort="{ prop: 'preview_count', order: 'descending' }">
            <el-table-column prop="resource_id" label="壁纸ID" :width="isSmallScreen ? 70 : 150">
              <template #default="scope">
                <el-tooltip
                  v-if="scope.row.resource_url"
                  placement="top"
                  effect="light"
                >
                  <template #content>
                    <video
                      v-if="scope.row.resource_url.includes('.mp4')"
                      :src="scope.row.resource_url"
                      controls
                      style="max-width: 200px; max-height: 300px;"
                    />
                    <img
                      v-else
                      :src="scope.row.resource_url"
                      style="max-width: 200px; max-height: 300px;"
                    />
                  </template>
                  <a href="javascript:void(0)" @click.prevent="openUrl(scope.row.resource_url)" style="color: #409EFF;">
                    {{ scope.row.resource_id }}
                  </a>
                </el-tooltip>
                <span v-else>{{ scope.row.resource_id }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="category" label="分类" :width="isSmallScreen ? 100 : 120" />
            <el-table-column prop="category_type" label="类型" :width="isSmallScreen ? 70 : 100" />
            <el-table-column prop="preview_count" label="预览PV" :width="isSmallScreen ? 70 : 100" sortable />
            <el-table-column prop="preview_count_uv" label="预览UV" :width="isSmallScreen ? 70 : 100" sortable />
            <el-table-column prop="apply_count" label="ApplyPV" :width="isSmallScreen ? 70 : 100" sortable />
            <el-table-column prop="apply_count_uv" label="ApplyUV" :width="isSmallScreen ? 70 : 100" sortable />
            <el-table-column prop="succ_count" label="成功PV" :width="isSmallScreen ? 70 : 100" sortable />
            <el-table-column prop="succ_count_uv" label="成功UV" :width="isSmallScreen ? 70 : 100" sortable />
            <el-table-column prop="apply_rate" label="Apply率(PV)" :width="isSmallScreen ? 70 : 100" sortable>
              <template #default="scope">
                {{ scope.row.apply_rate }}%
              </template>
            </el-table-column>
            <el-table-column prop="apply_rate_uv" label="Apply率(UV)" :width="isSmallScreen ? 70 : 100" sortable>
              <template #default="scope">
                {{ scope.row.apply_rate_uv }}%
              </template>
            </el-table-column>
            <el-table-column prop="succ_rate" label="Succ率(PV)" :width="isSmallScreen ? 70 : 100" sortable>
              <template #default="scope">
                {{ scope.row.succ_rate }}%
              </template>
            </el-table-column>
            <el-table-column prop="succ_rate_uv" label="Succ率(UV)" :width="isSmallScreen ? 70 : 100" sortable>
              <template #default="scope">
                {{ scope.row.succ_rate_uv }}%
              </template>
            </el-table-column>
            <el-table-column prop="avg_preview" label="人均预览" :width="isSmallScreen ? 70 : 90" sortable />
            <el-table-column prop="avg_apply" label="人均Apply" :width="isSmallScreen ? 70 : 90" sortable />
            <el-table-column prop="avg_succ" label="人均成功" :width="isSmallScreen ? 70 : 90" sortable />
          </el-table>
        </div>
      </el-tab-pane>

      <el-tab-pane label="Apply失败详情" name="failed">
        <div class="filter-bar" style="margin: 16px 0; gap: 16px;">
          <div class="filter-group">
            <span class="filter-label">错误码:</span>
            <el-select v-model="reasonMsg" placeholder="错误码" clearable filterable>
              <el-option label="All" value="All" />
              <el-option v-for="item in reasonMsgs" :key="item" :label="item" :value="item" />
            </el-select>
          </div>
          <div class="filter-group">
            <span class="filter-label">App版本:</span>
            <el-select v-model="appVersion" placeholder="App版本" clearable filterable>
              <el-option label="All" value="All" />
              <el-option v-for="item in appVersions" :key="item" :label="item" :value="item" />
            </el-select>
          </div>
          <div class="filter-group">
            <span class="filter-label">手机品牌:</span>
            <el-select v-model="mobileBrandName" placeholder="手机品牌" clearable filterable>
              <el-option label="All" value="All" />
              <el-option v-for="item in mobileBrandNames" :key="item" :label="item" :value="item" />
            </el-select>
          </div>
          <div class="filter-group">
            <span class="filter-label">手机型号:</span>
            <el-select v-model="mobileMarketingName" placeholder="手机型号" clearable filterable>
              <el-option label="All" value="All" />
              <el-option v-for="item in mobileMarketingNames" :key="item" :label="item" :value="item" />
            </el-select>
          </div>
          <div class="filter-group">
            <span class="filter-label">系统版本:</span>
            <el-select v-model="operatingSystemVersion" placeholder="系统版本" clearable filterable>
              <el-option label="All" value="All" />
              <el-option v-for="item in operatingSystemVersions" :key="item" :label="item" :value="item" />
            </el-select>
          </div>
        </div>
        <el-tabs v-model="failedSubTab" type="border-card" style="margin-top: 16px;">
          <el-tab-pane label="错误码分布统计" name="reason">
            <el-table :data="reasonStatsData" stripe border :loading="loading" max-height="500" :show-overflow-tooltip="true">
              <el-table-column prop="reason_msg" label="错误码" width="600" />
              <el-table-column prop="fail_count" label="失败次数(PV)" width="150" sortable />
              <el-table-column prop="fail_uv" label="失败用户数(UV)" width="150" sortable />
              <el-table-column prop="avg_fail" label="人均失败" width="120" sortable>
                <template #default="scope">
                  {{ (scope.row.fail_count / scope.row.fail_uv || 0).toFixed(2) }}
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="失败事件明细" name="detail">
            <div style="margin-bottom: 12px; color: #666; font-size: 12px;">最近1000条</div>
            <el-table :data="failedEventsData" stripe border :loading="loading" max-height="500" :default-sort="{ prop: 'dt', order: 'descending' }">
              <el-table-column prop="dt" label="日期" width="100" sortable />
              <el-table-column prop="ts" label="时间" width="150" sortable />
              <el-table-column prop="user_pseudo_id" label="用户ID" width="150" sortable />
              <el-table-column prop="reason_msg" label="错误码" width="200" sortable>
                <template #default="scope">
                  <span style="color: #E63D3D; font-weight: bold;">{{ scope.row.reason_msg }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="device_category" label="设备类型" width="100" sortable />
              <el-table-column prop="mobile_brand_name" label="手机品牌" width="120" sortable />
              <el-table-column prop="mobile_marketing_name" label="手机型号" width="120" sortable />
              <el-table-column prop="operating_system" label="操作系统" width="100" sortable />
              <el-table-column prop="operating_system_version" label="系统版本" width="100" sortable />
              <el-table-column prop="screen_resolution" label="分辨率" width="120" sortable />
              <el-table-column prop="version" label="App版本" width="100" sortable />
              <el-table-column prop="language" label="语言" width="80" sortable />
              <el-table-column prop="country" label="国家" width="80" sortable />
              <el-table-column prop="campaign_id" label="广告系列ID" width="150" sortable />
              <el-table-column prop="campaign_name" label="广告系列名称" width="150" sortable />
              <el-table-column prop="ad_group_id" label="广告组ID" width="150" sortable />
              <el-table-column prop="ad_group_name" label="广告组名称" width="150" sortable />
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>

      <el-tab-pane label="设备信息" name="device">
        <div v-loading="loading">
          <el-radio-group v-model="deviceViewType" style="margin-bottom: 16px;">
            <el-radio-button label="chart">图表</el-radio-button>
            <el-radio-button label="table">详细表格</el-radio-button>
          </el-radio-group>

          <div v-if="deviceViewType === 'chart'" :style="isSmallScreen ? 'display: flex; flex-wrap: wrap; gap: 20px;' : 'display: flex; flex-wrap: wrap; gap: 30px; padding: 0 40px;'">
            <div v-for="(chartData, key) in deviceChartData" :key="key" :style="isSmallScreen ? 'width: 100%; height: 380px;' : 'width: calc(50% - 15px); height: 400px;'">
              <h4 style="margin-bottom: 12px;">{{ getDeviceLabel(key) }} UV占比</h4>
              <div v-if="chartData && chartData.length > 0">
                <div :id="'pie-chart-' + key" style="width: 100%; height: 300px;"></div>
              </div>
              <div v-else style="color: #999; text-align: center; padding: 20px;">暂无数据</div>
            </div>
          </div>

          <div v-else style="display: flex; flex-wrap: wrap; gap: 20px; padding: 0 20px;">
            <div v-for="(tableData, key) in deviceChartData" :key="key" style="width: calc(50% - 10px);">
              <h4 style="margin-bottom: 12px;">{{ getDeviceLabel(key) }} UV占比</h4>
              <el-table :data="tableData" stripe border size="small" max-height="300">
                <el-table-column prop="label" label="维度" align="center" />
                <el-table-column prop="value" label="UV" sortable align="center" />
                <el-table-column prop="percentage" label="占比" sortable align="center">
                  <template #default="scope">
                    {{ scope.row.percentage }}%
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue'
import { get_wallpaper_category_stats, get_wallpaper_item_stats, get_wallpaper_device_stats, get_wallpaper_config, get_wallpaper_apply_failed_stats } from '../services/requests'
import { ElMessage } from 'element-plus'
import * as echarts from 'echarts'

const minDate = new Date('2026-05-12')

// 定时任务UTC时间9:30，即北京时间17:30
// 9点30前最大日期为前2天，9点30后最大日期为前1天
const TASK_HOUR_UTC = 9
const TASK_MINUTE = 30

function isAfterTaskTime() {
  const now = new Date()
  const utcHour = now.getUTCHours()
  const utcMinute = now.getUTCMinutes()
  const currentUtcMinutes = utcHour * 60 + utcMinute
  const taskUtcMinutes = TASK_HOUR_UTC * 60 + TASK_MINUTE
  return currentUtcMinutes >= taskUtcMinutes
}

const maxDate = computed(() => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const offset = isAfterTaskTime() ? 1 : 2
  const max = new Date(today)
  max.setDate(max.getDate() - offset)
  return max
})

const yesterday = computed(() => {
  return new Date(maxDate.value)
})

const defaultStart = computed(() => {
  const start = new Date(yesterday.value)
  start.setDate(start.getDate() - 6)
  if (start < minDate) {
    return new Date(minDate)
  }
  return start
})

const formatDate = (d) => {
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const dateRange = ref([formatDate(defaultStart.value), formatDate(yesterday.value)])
const activeTab = ref('category')
const loading = ref(false)
const categoryData = ref([])
const wallpaperData = ref([])
const wallpaperCategoryType = ref('All')
const deviceType = ref('All')
const country = ref('All')
const deviceTypes = ref([])
const countries = ref([])
const campaignIds = ref([])
const campaignNames = ref([])
const adGroupIds = ref([])
const adGroupNames = ref([])
const campaignId = ref('All')
const campaignName = ref('All')
const adGroupId = ref('All')
const adGroupName = ref('All')
const totalUV = ref(0)
const deviceChartData = ref({
  screen_resolution: [],
  device_category: [],
  mobile_brand_name: [],
  mobile_marketing_name: [],
  operating_system_version: [],
  language: [],
  country: []
})
const reasonMsgs = ref([])
const reasonMsg = ref('All')
const appVersions = ref([])
const appVersion = ref('All')
const mobileBrandNames = ref([])
const mobileBrandName = ref('All')
const mobileMarketingNames = ref([])
const mobileMarketingName = ref('All')
const operatingSystemVersions = ref([])
const operatingSystemVersion = ref('All')
const deviceViewType = ref('chart')
const reasonStatsData = ref([])
const failedEventsData = ref([])
const failedSubTab = ref('reason')

const isSmallScreen = computed(() => {
  return document.body.clientWidth < 1300
})

async function fetchConfig() {
  try {
    const res = await get_wallpaper_config()
    if (res.data.code === 200) {
      deviceTypes.value = res.data.data.device_categories || []
      countries.value = res.data.data.countries || []
      campaignIds.value = res.data.data.campaign_ids || []
      campaignNames.value = res.data.data.campaign_names || []
      adGroupIds.value = res.data.data.ad_group_ids || []
      adGroupNames.value = res.data.data.ad_group_names || []
      reasonMsgs.value = res.data.data.reason_msgs || []
      appVersions.value = res.data.data.app_versions || []
      mobileBrandNames.value = res.data.data.mobile_brand_names || []
      mobileMarketingNames.value = res.data.data.mobile_marketing_names || []
      operatingSystemVersions.value = res.data.data.operating_system_versions || []
    }
  } catch (e) {
    console.error('获取壁纸配置异常:', e)
  }
}

onMounted(() => {
  fetchConfig()
})

// 切换Tab时自动请求数据
watch(activeTab, () => {
  fetchData()
})

// 切换设备信息视图时重新渲染图表
watch(deviceViewType, (newVal) => {
  if (newVal === 'chart') {
    nextTick(() => renderDeviceCharts())
  }
})

// wallpaper tab 下的类型筛选变化时自动重新查询
watch(wallpaperCategoryType, () => {
  if (activeTab.value === 'wallpaper') {
    fetchData()
  }
})

const shortcuts = computed(() => {
  const end = new Date(yesterday.value)
  return [
    {
      text: '昨天',
      value: () => {
        const start = new Date(end)
        return [start, end]
      },
    },
    {
      text: '最近3天',
      value: () => {
        const start = new Date(end)
        start.setDate(start.getDate() - 2)
        if (start < minDate) {
          start.setTime(minDate.getTime())
        }
        return [start, end]
      },
    },
    {
      text: '最近7天',
      value: () => {
        const start = new Date(end)
        start.setDate(start.getDate() - 6)
        if (start < minDate) {
          start.setTime(minDate.getTime())
        }
        return [start, end]
      },
    },
    {
      text: '最近1个月',
      value: () => {
        const start = new Date(end)
        start.setDate(start.getDate() - 30)
        if (start < minDate) {
          start.setTime(minDate.getTime())
        }
        return [start, end]
      },
    },
    {
      text: '最近3个月',
      value: () => {
        const start = new Date(end)
        start.setMonth(start.getMonth() - 3)
        if (start < minDate) {
          start.setTime(minDate.getTime())
        }
        return [start, end]
      },
    },
    {
      text: '最近半年',
      value: () => {
        const start = new Date(end)
        start.setMonth(start.getMonth() - 6)
        if (start < minDate) {
          start.setTime(minDate.getTime())
        }
        return [start, end]
      },
    },
    {
      text: '最近1年',
      value: () => {
        const start = new Date(end)
        start.setFullYear(start.getFullYear() - 1)
        if (start < minDate) {
          start.setTime(minDate.getTime())
        }
        return [start, end]
      },
    },
    {
      text: '全部',
      value: () => {
        const start = new Date(minDate)
        return [start, end]
      },
    },
  ]
})

function disabledDate(date) {
  const minDateStart = new Date(minDate)
  minDateStart.setHours(0, 0, 0, 0)
  return date < minDateStart || date > maxDate.value
}

async function fetchData() {
  if (!dateRange.value || dateRange.value.length < 2) {
    ElMessage.warning('请选择日期范围')
    return
  }

  loading.value = true
  try {
    if (activeTab.value === 'failed') {
      // Apply失败详情Tab
      const params = {
        start_date: dateRange.value[0],
        end_date: dateRange.value[1],
        device_type: deviceType.value,
        country: country.value,
        campaign_id: campaignId.value,
        campaign_name: campaignName.value,
        ad_group_id: adGroupId.value,
        ad_group_name: adGroupName.value,
        reason_msg: reasonMsg.value,
        app_version: appVersion.value,
        mobile_brand_name: mobileBrandName.value,
        mobile_marketing_name: mobileMarketingName.value,
        operating_system_version: operatingSystemVersion.value
      }
      const res = await get_wallpaper_apply_failed_stats(params)
      if (res.data.code === 200) {
        reasonStatsData.value = res.data.data.reason_stats || []
        failedEventsData.value = res.data.data.failed_events || []
      } else {
        ElMessage.error(res.data.message || '获取数据失败')
      }
    } else if (activeTab.value === 'category') {
      // 壁纸分类热度榜
      const params = {
        start_date: dateRange.value[0],
        end_date: dateRange.value[1],
        device_type: deviceType.value,
        country: country.value,
        campaign_id: campaignId.value,
        campaign_name: campaignName.value,
        ad_group_id: adGroupId.value,
        ad_group_name: adGroupName.value
      }
      const res = await get_wallpaper_category_stats(params)
      if (res.data.code === 200) {
        categoryData.value = res.data.data.category_stats || []
      } else {
        ElMessage.error(res.data.message || '获取数据失败')
      }
    } else if (activeTab.value === 'wallpaper') {
      // 具体壁纸热度Top20
      const params = {
        start_date: dateRange.value[0],
        end_date: dateRange.value[1],
        device_type: deviceType.value,
        country: country.value,
        campaign_id: campaignId.value,
        campaign_name: campaignName.value,
        ad_group_id: adGroupId.value,
        ad_group_name: adGroupName.value,
        category_type: wallpaperCategoryType.value
      }
      const res = await get_wallpaper_item_stats(params)
      if (res.data.code === 200) {
        wallpaperData.value = res.data.data.wallpaper_stats || []
      } else {
        ElMessage.error(res.data.message || '获取数据失败')
      }
    } else if (activeTab.value === 'device') {
      // 设备信息UV占比
      const params = {
        start_date: dateRange.value[0],
        end_date: dateRange.value[1],
        device_type: deviceType.value,
        country: country.value,
        campaign_id: campaignId.value,
        campaign_name: campaignName.value,
        ad_group_id: adGroupId.value,
        ad_group_name: adGroupName.value
      }
      const res = await get_wallpaper_device_stats(params)
      if (res.data.code === 200) {
        totalUV.value = res.data.data.total_uv || 0
        deviceChartData.value.screen_resolution = res.data.data.screen_resolution || []
        deviceChartData.value.device_category = res.data.data.device_category || []
        deviceChartData.value.mobile_brand_name = res.data.data.mobile_brand_name || []
        deviceChartData.value.mobile_marketing_name = res.data.data.mobile_marketing_name || []
        deviceChartData.value.operating_system_version = res.data.data.operating_system_version || []
        deviceChartData.value.language = res.data.data.language || []
        deviceChartData.value.country = res.data.data.country || []
        renderDeviceCharts()
      } else {
        ElMessage.error(res.data.message || '获取数据失败')
      }
    }
  } catch (e) {
    ElMessage.error('请求异常: ' + e.message)
  } finally {
    loading.value = false
  }
}

function openUrl(url) {
  window.open(url, '_blank')
}

function getDeviceLabel(key) {
  const labels = {
    screen_resolution: '屏幕分辨率',
    device_category: '设备类型',
    mobile_brand_name: '手机品牌',
    mobile_marketing_name: '手机型号',
    operating_system_version: '系统版本',
    language: '语言',
    country: '国家'
  }
  return labels[key] || key
}

function loadPieChart(key, data) {
  nextTick(() => {
    const chartDom = document.getElementById('pie-chart-' + key)
    if (!chartDom) return
    let myChart = echarts.getInstanceByDom(chartDom)
    if (myChart) {
      myChart.dispose()
    }
    const width = chartDom.parentElement.clientWidth || 500
    const height = 320
    chartDom.style.width = width + 'px'
    chartDom.style.height = height + 'px'
    myChart = echarts.init(chartDom)

    // 限制显示前8条，其余合并为"其他"
    const MAX_ITEMS = 8
    let chartData = data
    if (data.length > MAX_ITEMS) {
      const topData = data.slice(0, MAX_ITEMS)
      const othersSum = data.slice(MAX_ITEMS).reduce((sum, item) => sum + item.value, 0)
      chartData = [...topData, { name: '其他', value: othersSum }]
    }

    const isSmall = isSmallScreen.value
    const option = {
      title: {
        text: getDeviceLabel(key),
        left: 'center'
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c} ({d}%)'
      },
      legend: isSmall ? {
        orient: 'horizontal',
        bottom: 0,
        left: 'center'
      } : {
        orient: 'vertical',
        left: 30,
        top: 30
      },
      series: [
        {
          type: 'pie',
          radius: '55%',
          center: isSmall ? ['50%', '45%'] : ['55%', '50%'],
          data: chartData,
          label: {
            show: true,
            formatter: '{b}: {c} ({d}%)'
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    }
    myChart.setOption(option)
  })
}

function renderDeviceCharts() {
  for (const key in deviceChartData.value) {
    const data = deviceChartData.value[key]
    if (data && data.length > 0) {
      const chartData = data.map(item => ({
        name: item.label,
        value: item.value
      }))
      loadPieChart(key, chartData)
    }
  }
}
</script>

<style scoped>

.filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
}

.date-picker {
  flex-shrink: 0;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

.filter-group :deep(.el-select) {
  width: 130px;
}
</style>